import { useMemo } from 'react';

import { Subheading } from '@/components/Typography';
import { TableCell, TableRow } from '@/elements/Table';
import Text from '@/elements/Text';
import { InvoiceItem } from '@/types/graphql';
import { centsToCurrency } from '@/util/number';

type Props = {
  invoice: any;
  invoiceItems: InvoiceItem[];
  editable: boolean;
};

const TotalsRow = ({ invoice, editable, invoiceItems }: Props) => {
  const total = centsToCurrency(invoice.amountDue);
  // Sum the per-line displayed hours (already truncated to 2dp by the
  // backend) so the total matches what a client gets when adding the column.
  const totalHoursLabel = useMemo(() => {
    const sumHours = invoiceItems.reduce((sum, item) => {
      const hours = Number(item.netTime);
      return Number.isFinite(hours) ? sum + hours : sum;
    }, 0);
    return sumHours.toFixed(2);
  }, [invoiceItems]);
  return (
    <>
      <TableRow
        key={`totals-row`}
        css={{
          backgroundColor: '#EEFFEC !important',
        }}
      >
        <TableCell colSpan={3}>
          <Subheading>Total</Subheading>
        </TableCell>
        <TableCell>
          <Text weight={'semibold'}>{totalHoursLabel}</Text>
        </TableCell>
        <TableCell colSpan={4} />
        <TableCell>
          <Text weight={'semibold'}>${total}</Text>
        </TableCell>
        {editable && <TableCell />}
      </TableRow>
    </>
  );
};

export default TotalsRow;
